/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { selectCategory as selectCategoryOrchestrator } from 'owa-options-store';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
import { OptionCategory } from 'owa-options-core';

export default orchestratorAction('selectCategory', function selectCategory(
    category: OptionCategory
) {
    const continueAfterConfirmCallback = () => {
        selectCategoryOrchestrator(category);
    };

    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
